import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import { withTranslation } from "react-i18next";

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

const Section2 = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'testimonial section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'testimonial-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap',
    pushLeft && 'push-left'
  );

  const content = {
    "title": "Your Key to Success",
    "paragraph": {
      "kw1": "Created by Yomi Denzel",
      "p1": "",
      "p2": ""
    },
    "comment": {
      "name": " Yomi Denzel",
      "text": {
        "line1": "There is no software as powerful as Ecomspy. You must use it if you are serious about your business."

      }
    }
  }

  const {id, t} = props;

  return (
    <section
      id={id}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={content} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-right" data-reveal-delay="200">

              <div className="tiles-item-inner">
                <img
                  src={require('./../../assets/images/denzel.jpg')}
                  alt="avatar_quote"
                  style={{borderRadius: "50%", width : "100px",  margin:'auto'}}
                />
                <div>
                  <div className="testimonial-item-content" >
                    {content.comment && <p className="text-sm mb-0 center-content">
                      - {t(content.comment.text.line1)}
                      </p>
                    }
                  </div>
                  <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider center-content">
                    <span className="testimonial-item-name text-color-high">{content.comment.name}</span>
                    <span className="text-color-low"> / </span>
                    <span className="testimonial-item-link">
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

Section2.propTypes = propTypes;
Section2.defaultProps = defaultProps;

export default withTranslation()(Section2);
